import { FbLink, FooterHead, FooterQuote } from "../../constants";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer: React.FC<{}> = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div className="col-lg-3 col-md-6 footer-info">
              <h5 style={{ fontSize: "1.5rem" }}>{FooterHead}</h5>
            </div>
            <div
              className="col-lg-3 col-md-6 footer-info"
              style={{ width: "30rem" }}
            >
              {FooterQuote}
            </div>
            <div className="col-lg-3 col-md-6 footer-contact">
              <div className="social-links">
                <a href={FbLink} className="facebook">
                  <FontAwesomeIcon icon={faFacebook} size="2x" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
